import {CloseOutlined} from '@mui/icons-material';
import {IconButton} from '@mui/material';
import {Slide, ToastContainer} from 'react-toastify';

const Notifier = () => (
  <ToastContainer
    position="top-center"
    autoClose={5000}
    hideProgressBar
    icon={false}
    limit={5}
    newestOnTop
    closeOnClick={false}
    rtl={false}
    draggable={false}
    pauseOnHover
    theme="colored"
    transition={Slide}
    closeButton={({closeToast}) => (
      <IconButton
        aria-label="Close"
        size="small"
        onClick={closeToast}
        sx={{alignSelf: 'baseline', marginInlineEnd: -1}}
      >
        <CloseOutlined fontSize="small" color="inherit" />
      </IconButton>
    )}
  />
);

export default Notifier;
